import AppRoleRoutes from "./AppRoleRoutes";

export default AppRoleRoutes;
